module.exports = __webpack_public_path__ + "img/date-icon.dce7b09d.svg";